import { render, staticRenderFns } from "./pos-menuButtons.vue?vue&type=template&id=5e17edbf&"
import script from "./pos-menuButtons.vue?vue&type=script&lang=js&"
export * from "./pos-menuButtons.vue?vue&type=script&lang=js&"
import style0 from "./pos-menuButtons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports